module.exports = __webpack_public_path__ + "media/机器人实操基地1.e08eaef3.mp4";